import React, { SyntheticEvent } from "react";
import { Rifm } from 'rifm';
import Question from '../components/Question'
import QuoteStepBase from '../components/QuoteStepBase'
import { Card, InputGroup, Button, Form, FormControl, Col } from 'react-bootstrap'
import QuoteStep from "./QuoteStepLayout";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import { IAppState } from "../state/interfaces";
import { connect } from "react-redux";
import { QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS, MARIED_TYPES } from "../AppConstants";
import { ValidatableForm } from "../components/ValidatableForm"
import { ValidatableFormGroup } from "../components/ValidatableFormGroup"
import Utilities from "../classes/Utilities";
import { validationUtils } from "../validation/Validation";
import ButtonContinue from "../components/ButtonContinue";
import { IQuoteApiClient, IPaths, IDriver, IIncidentInfo, IAddress } from "../classes/Domain";
import QuoteActions from "../state/appActions";
import ComplexCheckbox from "../components/ComplexCheckbox";


interface IState extends IQuoteStepState {
    firstName: string,
    lastName: string,
    birthDate: string,
    gender: string,
    maritalStatus: string,
    isExcluded: boolean;
}

export interface IProps extends IDriverStepProps {
    insured: IDriver,
    nextPageUrl?: string,
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

class AboutYou extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);

        this.state = {
            firstName: "",
            lastName: "",
            birthDate: "",
            gender: "",
            maritalStatus: this.props.driverIndex == 1 && MARIED_TYPES.includes(this.props.insured.maritalStatus) ? this.props.insured.maritalStatus : "",
            updatingStore: false,
            isExcluded: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    setStateValue(value: string, property: string) {
        const obj = {};
        obj[property] = value;
        this.setState({ ...this.state, ...obj });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const driver = nextProps.driver;
            nextProps.meta.propsSource = "";

            if (null === driver) return prevState;
            
            return {
                ...prevState,
                firstName: driver.firstName,
                lastName: driver.lastName,
                birthDate: driver.birthDate,
                gender: driver.gender,
                maritalStatus: driver.maritalStatus,
                isExcluded: driver.isExcluded
            };
        }

        return prevState;
    }

    next() {
        this.setState({ updatingStore: true }, () => {

            const updatedDriver = {
                ...this.props.driver,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                birthDate: this.state.birthDate,
                gender: this.state.gender,
                maritalStatus: this.state.maritalStatus,
                isInsured: 0 === this.props.driverIndex,
                isExcluded: 0 === this.props.driverIndex ? false : this.state.isExcluded
            };

            if (updatedDriver.isExcluded) {
                updatedDriver.incidents = new Array<IIncidentInfo>();
                updatedDriver.accidentsViolations = QUOTE_QUESTIONS.YES_NO.NO;
            }

            let nextStepUrl = Utilities.formatUrl(updatedDriver.isInsured
                ? this.props.PATHS.YOUR_HOME
                : this.state.isExcluded
                    ? this.props.PATHS.DRIVING_HISTORY
                    : this.props.PATHS.YOUR_LICENSE,
                (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""));

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(nextStepUrl, (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""))),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    genderCallbackFunction = (childData: string) => {
        this.setState({ ...this.state, gender: childData });
    };

    maritalStatusCallbackFunction = (childData: string) => {
        this.setState({ ...this.state, maritalStatus: childData });
    };

    getDescription()
    {
        let drNumber = this.props.driverIndex + 1;

        if (this.props.driverIndex == 0) {
            return "ABOUT YOU";
        }
        else if (this.props.driverIndex == 1 && MARIED_TYPES.includes(this.props.insured.maritalStatus)) {
            return "ABOUT YOUR SPOUSE";
        }
        else {
            return 'ABOUT DRIVER #' + drNumber + '';
        }
    }

    handleExcludedChange(event: SyntheticEvent, property: string) {
        var val = this.state[property];
        val = !val;
        this.setStateValue(val, property);
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea">
                    <h5>{this.getDescription()}</h5>
                </div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <ValidatableFormGroup
                        label="First Name"
                        className="col-left"
                        value={this.state.firstName}
                        validated={null !== this.state.errors}
                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "firstName")}
                        onChange={(e) => { this.setStateValue(e.target.value, "firstName") }} />

                    <ValidatableFormGroup
                        label="Last Name"
                        className="col-right"
                        value={this.state.lastName}
                        validated={null !== this.state.errors}
                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "lastName")}
                        onChange={(e) => { this.setStateValue(e.target.value, "lastName") }} />

                    <Form.Row>
                        <Rifm
                            accept={/\d/g}
                            mask={10 <= this.state.birthDate.length}
                            format={Utilities.formatDate}
                            value={this.state.birthDate}
                            onChange={(v) => { this.setStateValue(v, "birthDate") }}>
                            {({ value, onChange }) => (
                                <ValidatableFormGroup
                                    label="Birthdate"
                                    className="col-right"
                                    placeholder="mm/dd/yyyy"
                                    value={value}
                                    validated={null !== this.state.errors}
                                    validationError={validationUtils.getValidationErrorFor(this.state.errors, "birthDate")}
                                    onChange={(e) => { onChange(e) }}
                                    pattern="[0-9]*"
                                    inputmode="numeric" />
                            )}
                        </Rifm>
                    </Form.Row>


                    <Question
                        name="maritalStatus"
                        items={[
                            QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.SINGLE,
                            QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.MARRIED,
                            //QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.DIVORCED,
                            //QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.WIDOWED,
                            //QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.CIVIL_UNION,
                            //QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.SEPARATED,
                            QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.REGISTERED_DOMESTIC_PARTNER,
                            QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.DOMESTIC_PARTNER
                        ]}
                        lable="Marital Status"
                        disabled={this.props.driverIndex == 1 && MARIED_TYPES.includes(this.props.insured.maritalStatus)}
                        selected={this.maritalStatusCallbackFunction}
                        selectedValue={this.state.maritalStatus}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "maritalStatus")} />

                    {
                        this.props.stateCode === "TX"
                            ?
                            <Question
                                name="gender"
                                error={validationUtils.hasValidationErrorFor(this.state.errors, "gender") ? this.state.errors["gender"][0] : ""}
                                selectedValue={this.state.gender}
                                selected={this.genderCallbackFunction}
                                items={[QUOTE_QUESTIONS.ABOUT_YOU.GENDER.MALE, QUOTE_QUESTIONS.ABOUT_YOU.GENDER.FEMALE]}
                                lable="Gender" />
                            : null
                    }

                    {
                        this.props.driverIndex > 0
                            ?
                            <ComplexCheckbox
                                children={
                                    <div>
                                        <Form.Check.Label>Exclude as Driver</Form.Check.Label>
                                    </div>
                                }
                                value={this.state.isExcluded}
                                onChange={(e) => this.handleExcludedChange(e, "isExcluded")} />
                            : null
                    }

                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverIndex = !ownProps.match.params["driverIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverIndex"], 10);

    return {
        quoteUid: state.quoteUid,
        driverIndex: driverIndex,
        insured: driverIndex > 0 ? state.drivers[0] : null,
        driver: driverIndex < state.drivers.length ? state.drivers[driverIndex] : null,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.ABOUT_YOU)),
        updateAppState: (update) => dispatch(quoteActions.updateDriver(update.quoteUid, update.driver, QUOTE_STEPS.ABOUT_YOU, ownProps.stateCode))
    };
};

export default connect(mapProps, mapDispatch)(AboutYou);
